import { useLoaderData as useLoaderDataRR } from 'react-router-dom';
export function useLoaderData() {
    return useLoaderDataRR();
}
